import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { PagedResult } from '../../shared/model/generic-paged-result.model';
import { Table as PrimeDataTable } from 'primeng/table';
import { DatagridService, PagedResultGeneric } from '../../shared/index';
import { TranslationService, NotificationService, UtilService } from '../../shared/index';

import { RevenueItemService } from '../shared/revenue-items/revenue-item.service';
import { RevenueItem } from '../shared/revenue-items/revenue-item.model';
import { ArcFormula, ArcService, ArcSearch } from '../shared/arc/index';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';
import { debounce } from 'lodash-decorators';

@Component({
  selector: 'wl-arc-dashboard',
  templateUrl: 'arc-dashboard.component.html',
    standalone: false
})
export class ArcDashboardComponent extends LazySelectableTableComponent<ArcSearch, ArcFormula> implements OnInit {
  private _arcService: ArcService;
  private _revenueItemService: RevenueItemService;
  private _translationService: TranslationService;
  private _notificationService: NotificationService;
  private _utilService: UtilService;
  private _arcToDelete: ArcFormula;
  private _router: Router;

  public revenueItems: Array<RevenueItem>;
  public datagridService: DatagridService;
  public arcsResult: PagedResult<Array<ArcFormula>> = new PagedResult<Array<ArcFormula>>([]);
  public isBusy: boolean = false;
  public isSearching: boolean = false;
  public deleting: boolean = false;
  public showModal = false;

  public constructor(
    arcService: ArcService,
    datagridService: DatagridService,
    revenueItemService: RevenueItemService,
    translationService: TranslationService,
    notificationService: NotificationService,
    utilService: UtilService,
    router: Router
  ) {
    super('ArcID', datagridService);
    this._arcService = arcService;
    this._translationService = translationService;
    this._notificationService = notificationService;
    this._utilService = utilService;
    this._revenueItemService = revenueItemService;
    this._router = router;
    this.datagridService = datagridService;
    this.searchParams = new ArcSearch();
  }

  ngOnInit() {}

  fetchResults(): Promise<PagedResultGeneric<ArcFormula>> {
    return this._arcService.searchArcs(this.searchParams);
  }

  @debounce(500)
  filterChanged() {
    this.getArcs();
  }

  public lazyLoadArcFormulas($event: any): void {
    this.datagridService.mapDatagridPagingToPagedSearch($event, this.searchParams);

    if (!this.isSearching) {
      if (this.revenueItems == null) {
        this._revenueItemService.getRevenueItems().then((data: Array<RevenueItem>) => {
          this.revenueItems = data;
          this.getArcs();
        });
      } else {
        this.getArcs();
      }
    }
  }

  public getArcs(): void {
    if (this.isSearching) return;

    this.isSearching = true;

    this.fetchResults().then(
      (result: PagedResult<Array<ArcFormula>>) => {
        this.datagridService.mapPagedResultsToPagedSearch(result, this.searchParams);
        this.arcsResult = result;
        this.isSearching = false;
      },
      () => {
        this.isSearching = false;
      }
    );
  }

  public getRevenueItemName(itemNum: number): string {
    return this.revenueItems.find((x) => x.ItemNum == itemNum).ItemName;
  }

  public confirmDeleteArc(arc: ArcFormula): void {
    if (this.deleting || !arc || !arc.ArcID) return;

    this._arcToDelete = arc;

    this.showModal = true;
  }

  public editArc(arc: ArcFormula): void {
    this._router.navigate(['revenue/pricing-calculations/', arc.ArcID]);
  }

  public deleteArcConfirmed(): void {
    if (this.deleting || !this._arcToDelete) return;

    this.deleting = true;

    this._arcService.deleteArc(this._arcToDelete.ArcID).then(
      () => {
        this.deleting = false;

        this._translationService.get('revenue.arc.arc-deleted').then((message: string) => {
          this._notificationService.success(message);
        });

        this.showModal = false;

        this.getArcs();
      },
      () => {
        this.deleting = false;
      }
    );
  }
}
